export default __webpack_public_path__ + "static/media/tab-icon-1-sm.70b3db33.svg";